export default "__VITE_ASSET__CNNrYrev__"